/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

type IconPosition = 'start' | 'end' | null;

@Component({
    selector: '[luiTextButton]',
    template: `
    <span class="lui-text-btn-container" #trigger>
      <span
        class="lui-text-btn-icon-container"
        matRipple
        [matRippleTrigger]="trigger"
      >
        <ng-content select="mat-icon"></ng-content>
      </span>
      <ng-content></ng-content>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextButton {
  private _model = 'lui-text-btn';
  @HostBinding('class') get hostClasses() {
    return {
      [`${this._model}`]: true,
      [`${this._model}-icon-${this.iconPosition}`]: this.iconPosition !== null,
    };
  }

  @Input() iconPosition: IconPosition = null;
}
